/**
 * Route for `invalid-device-id-filtering`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvalidDeviceIdFilteringPage } from "../features/invalid-device-id-filtering/InvalidDeviceIdFilteringPage";

export const invalidDeviceIdFilteringRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invalid-device-id-filtering",
	component: InvalidDeviceIdFilteringPage,
});

export default invalidDeviceIdFilteringRoute;
